import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './App.css';

const RedirectToStore = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

    // Android detection
    if (/android/i.test(userAgent)) {
      window.location.href = "https://play.google.com/store/apps/details?id=com.zigliad.bhd1";
      return;
    }

    // iOS detection
    if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
      window.location.href = "https://apps.apple.com/app/id6757281547";
      return;
    }

    // Fallback to homepage
    navigate('/');
  }, [navigate]);

  return (
    <div className="App">
      <div className="hero-section" style={{ minHeight: '100vh', padding: 0 }}>
        <div className="hero-content">
          <div className="app-logo-container">
            <img 
              src="/bhd1/adaptive-icon.png" 
              alt="Loading..." 
              className="app-emblem-img" 
              style={{ width: '120px' }}
            />
          </div>
          <h1 className="app-tagline" style={{ marginTop: '20px' }}>
            מעביר אותך לחנות...
          </h1>
        </div>
      </div>
    </div>
  );
};

export default RedirectToStore;
